export enum DashUpdateStatus {
    Loading = 'loading',
    Successed = 'successed',
    Failed = 'failed',
}
